module.exports = __webpack_public_path__ + "static/img/dq4.47d751e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq4.png
// module id = MR1O
// module chunks = 0